/**
 * jQuery UnveilBackgroundImage
 */

const UnveilBackgroundImage = ($ => ({
  init: () => {
    $.fn.unveilBg = function (height, fn) {
      let $this = this
      const $window = $(window)
      const src = window.devicePixelRatio > 1 ? 'data-bgimgurl-retina' : 'data-bgimgurl'
      const ext = /\.(jpe?g|png|gif)$/

      function cb() {
        const unveilBgcb = $this.filter(function () {
          const $this2 = $(this)
          if (!$this2.is(':hidden')) {
            const scrollTop = $window.scrollTop()
            const padHeight = scrollTop + $window.height()
            const offsetTop = $this2.offset().top
            const topHeight = offsetTop + $this2.height()

            return scrollTop - height <= topHeight && offsetTop <= padHeight + height
          }

          return false
        })
        $this = $this.not(unveilBgcb.trigger('unveilBg'))
      }

      this.one('unveilBg', function () {
        const finalSrc = this.getAttribute(src) || this.getAttribute('data-bgimgurl')
        if (finalSrc) {
          Modernizr.webp ?
            this.setAttribute('style', `background-image: url('${finalSrc.replace(ext, '.webp')}')`) :
            this.setAttribute('style', `background-image: url('${finalSrc}')`)
          typeof fn === 'function' && fn.call(this)
        }
      })

      $window.on('scroll.unveilBg resize.unveilBg lookup.unveilBg', cb)
      cb()
      return this
    }
  },
}))(jQuery)

export default UnveilBackgroundImage
